/**
 * Field styling for the editor workspace.
 *
 * Separate from `utils/listingStyles.js` on purpose: that module still dresses
 * the image panels and the legacy card, and its `labelClass` is a 10px
 * uppercase caption. These are the workspace's own, built from the semantic
 * theme tokens (`border-border`, `bg-background`, `text-foreground`, …) so both
 * themes follow the palette instead of a second hard-coded hex list.
 */

export const fieldLabel = "mb-1.5 block text-[13px] font-medium text-foreground";

export const fieldInput =
  "w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export const fieldHint = "mt-1.5 text-[12px] text-muted-foreground";

export const fieldError = "mb-2 text-[13px] text-rose-500";

/** A checkbox or radio and its caption on one line. */
export const choiceRow =
  "flex cursor-pointer items-center gap-2 text-sm text-foreground";

/** Two equal columns from `sm` up, stacked below it. */
export const grid2 = "grid gap-5 sm:grid-cols-2";

/** Four equal columns from `sm` up, two below it. */
export const grid4 = "grid grid-cols-2 gap-5 sm:grid-cols-4";

/**
 * One column, two from `sm`, four from `lg`. For groups of short numeric
 * fields that must not be squeezed to four columns on a tablet.
 */
export const grid4Wide = "grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4";
